import {Agent, request} from './base';
import {User} from 'models/user';
import {UserTranslator} from 'models/user-translator';

export class UserAgent extends Agent<User> {
    constructor() {
        super(User, '/users');
    }

    roles = {
        del: async (userId: number, roleIds: number[]) => {
            return request.del(`/users/roles/${userId}`, roleIds);
        },
        create: async (userId: number, roleIds: number[]) => {
            return request.post(`/users/roles/${userId}`, roleIds);
        },
    };

    translator = new Agent(UserTranslator, '/users/translator');

    login = async (payload: { username: string; password: string }) => {
        const {refreshToken} = await request.post('/users/sessions', payload);
        localStorage.setItem('refresh-token', refreshToken);
    };

    logout = async () => {
        await request.del('/users/sessions');
        localStorage.removeItem('refresh-token');
    };

    updatePassword = async (userId: number, password: string) => {
        return request.put(`/users/${userId}/password`, {password});
    };

    authenticate = () => {
        return request.get('/users/authentication');
    };

    getSessions = () => {
        return request.get('/users/sessions');
    };

    deleteSession = (id: number) => {
        return request.del(`/users/sessions/$${id}`);
    };
}